import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insufficient-search-credits',
  templateUrl: './insufficient-search-credits.component.html',
  styleUrls: ['./insufficient-search-credits.component.scss']
})
export class InsufficientSearchCreditsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
